import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";
import FAQ from "../views/FAQ.vue";
import Status from "../views/Status.vue";
import About from "../views/About.vue";
import LandlordSurvey from "../views/LandlordSurvey.vue";
import TenantSurvey from "../views/TenantSurvey.vue";
import SurveySuccess from "../views/SurveySuccess.vue";
import Ledger from "../views/Ledger.vue";
import ResubmissionPage from "../views/ResubmissionPage.vue";
import AffidavitForm from "../views/AffidavitForm.vue";
import LandlordSuccessPage from "../views/LandlordSuccessPage.vue";
import TenantSuccessPage from "../views/TenantSuccessPage.vue";
import PathwayChange from "../views/PathwayChange.vue";
//import DetailedApplication from "../views/DetiledApplication.vue";
//import BankAccountSearch from "../views/BankAccountSearch.vue";
import ResubmissionSuccess from "../views/ResubmissionSuccess.vue";
import ResubmissionTFASuccess from "../views/ResubmissionTFASuccess.vue";
import PathwayChangeSuccess from "../views/PathwayChangeSuccess.vue";
import ResourcesPage from "../views/ResourcesPage.vue";
import DirectNegotiationGuide from "../views/DirectNegotiationGuide.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home,
  },
  {
    path: "/ResourcesPage",
    name: "ResourcesPage",
    component: ResourcesPage,
  },
  {
    path: "/DirectNegotiationGuide",
    name: "DirectNegotiationGuide",
    component: DirectNegotiationGuide,
  },
  // {
  //   path: "/BankAccountSearch/:applicantId",
  //   props: true,
  //   name: "BankAccountSearch",
  //   component: BankAccountSearch,
  // },
  {
    path: "/PathwayChange/:appid",
    props: true,
    name: "PathwayChange",
    component: PathwayChange,
  },
  {
    path: "/TenantSuccessPage/:applicantId?",
    props: true,
    name: "TenantSuccessPage",
    component: TenantSuccessPage,
  },
  {
    path: "/LandlordSuccessPage/:applicantId?",
    props: true,
    name: "LandlordSuccessPage",
    component: LandlordSuccessPage,
  },
  {
    path: "/PathwayChangeSuccess",
    name: "PathwayChangeSuccess",
    component: PathwayChangeSuccess,
  },
  {
    path: "/ResubmissionSuccess",
    name: "ResubmissionSuccess",
    component: ResubmissionSuccess,
  },
  {
    path: "/ResubmissionTFASuccess/:financialSpecialistEmail",
    props: true,
    name: "ResubmissionTFASuccess",
    component: ResubmissionTFASuccess,
  },
  {
    path: "/AffidavitForm/:applicantId",
    props: true,
    name: "AffidavitForm",
    component: AffidavitForm,
    meta: {
      analytics: {
        path: "/AffidavitForm/",
      },
    },
  },
  {
    path: "/LandlordApplication",
    name: "LandlordApplication",
    props: true,
    component: () =>
      import(
        /* webpackChunkName: "LandlordApplication" */ "../views/LandlordApplication.vue"
      ),
    meta: {
      analytics: {
        path: "/LandlordApplication/",
      },
    },
  },
  {
    path: "/TenantApplication/:applicantId",
    props: true,
    name: "TenantApplication",
    component: () =>
      import(
        /* webpackChunkName: "LandlordFileUpload" */ "../views/TenantApplication.vue"
      ),
    meta: {
      analytics: {
        path: "/TenantApplication/",
      },
    },
  },
  {
    path: "/LandlordFileUpload/:applicantId",
    props: true,
    name: "LandlordFileUpload",
    component: () =>
      import(
        /* webpackChunkName: "LandlordFileUpload" */ "../views/LandlordFileUpload.vue"
      ),
    meta: {
      analytics: {
        path: "/LandlordFileUpload/",
      },
    },
  },
  {
    path: "/LandlordAdditionalFileUpload/:applicantId",
    props: true,
    name: "LandlordAdditionalFileUpload",
    component: () =>
      import(
        /* webpackChunkName: "LandlordFileUpload" */ "../views/LandlordAdditionalFileUpload.vue"
      ),
    meta: {
      analytics: {
        path: "/LandlordAdditionalFileUpload/",
      },
    },
  },
  {
    path: "/Success/:applicantId?",
    props: true,
    name: "Success",
    component: () =>
      import(
        /* webpackChunkName: "Success" */ "../views/Success.vue"
      ),
    meta: {
      analytics: {
        path: "/Success/",
      },
    },
  },
  {
    path: "/Status/:applicantId?",
    props: true,
    name: "Status",
    component: Status,
    meta: {
      analytics: {
        path: "/Status/",
      },
    },
  },
  {
    path: "/FAQ",
    name: "FAQ",
    component: FAQ,
    meta: {
      analytics: {
        path: "/FAQ/",
      },
    },
  },
  {
    path: "/About",
    name: "About",
    component: About,
    meta: {
      analytics: {
        path: "/About/",
      },
    },
  },
  {
    path: "/LandlordSurvey/:applicantId",
    props: true,
    name: "LandlordSurvey",
    component: LandlordSurvey,
    meta: {
      analytics: {
        path: "/LandlordSurvey/",
      },
    },
  },
  {
    path: "/TenantSurvey/:applicantId",
    props: true,
    name: "TenantSurvey",
    component: TenantSurvey,
    meta: {
      analytics: {
        path: "/TenantSurvey/",
      },
    },
  },
  {
    path: "/SurveySuccess",
    name: "SurveySuccess",
    component: SurveySuccess,
    meta: {
      analytics: {
        path: "/SurveySuccess/",
      },
    },
  },
  {
    path: "/Ledger/:applicantId",
    props: true,
    name: "Ledger",
    component: Ledger,
    meta: {
      analytics: {
        path: "/Ledger/",
      },
    },
  },
  {
    path: "/DetailedApplication/:applicantId",
    props: true,
    name: "DetailedApplication",
    component: () =>
      import(
      /* webpackChunkName: "DetailedApplication" */ "../views/DetailedApplication.vue"
      ),
    meta: {
      analytics: {
        path: "/DetailedApplication/",
      },
    },
  },
  {
    path: "/ResubmissionPage/:appid&:llname/:llphone&:llemail/:marname&:marphone/:maremail&:pmrarname/:pmrarphone&:pmraremail/:tname&:tphone/:temail&:licensenumber/:ledger&:bankstatement/:affidavit&:nine/:nor&:ssn/:rentproof&:lease/:authorization&:businees/:w9address&:bankaccountname/:tenantaddress&:edpstatus/:resubmissions",
    props: true,
    component: ResubmissionPage,
    meta: {
      analytics: {
        path: "/ResubmissionPage",
      },
    },
  },
];

const router = new VueRouter({
  routes,
  scrollBehavior () {
    return { x: 0, y: 0 };
  },
});

export default router;
